if (!customElements.get('collections-slider')) {
  class CollectionsSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);
    }

    initSlider(swiperOptions) {
      console.log('slider is a go!',swiperOptions.spaceBetweenMobile)
      this.slider = new Swiper(this, {
        slidesPerView: 1.1,

        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          750: {
            enabled: true,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: 4,
            loop: false,
          }
        }
      });
    }
  }

  customElements.define('collections-slider', CollectionsSlider);
}
